import Select from "react-select";
import React, { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import { IAreaResponsable } from "../../entities/IAreaResponsable";
import IPlan from "../../entities/IPlan";
import { ITipoProceso } from "../../entities/ITipoProceso";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import UserPicker from "../../controls/UserPicker";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import {
  API_ADMIN_AREA_RESPONSABLE,
  API_ADMIN_TIPO_PROCESO,
  API_PROVEEDOR_GET_PLANIFICACIONES,
  ROW_COUNT,
  URL_PROVIDER,
  URL_SUPPORT,
} from "../../helpers/variableHelper";
import { getAPI, postAPI } from "../../helpers/httpHelper";
import { E_EstadoFormPrograma } from "../../enums/E_EstadoProveedor";
import { cParamsActiveOrderTitle } from "../../helpers/paramsHelper";
const MySwal = withReactContent(Swal);
interface IAgregarProgramaProps {
  plan?: IPlan;
  correlativo?: string;
  cbAr?: Array<IAreaResponsable>;
  estadoTest?: number;
  cbTP?: Array<ITipoProceso>;
  is_Test?: boolean;
  id_proveedor?: string;
}
export default function AgregarPrograma({ plan, correlativo, cbAr, estadoTest, cbTP, is_Test = false, id_proveedor = "0" }: IAgregarProgramaProps) {
  //
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const refTxtAnio = React.createRef<HTMLInputElement>();

  const [isSendingData] = useState(false);

  const [ar, setAR] = useState<IComboboxOption | null>(null);
  const [tp, setTP] = useState<IComboboxOption | null>(null);
  const [comboAR, setComboAR] = useState<Array<IAreaResponsable>>(cbAr || []);
  const [comboTP, setComboTP] = useState<Array<ITipoProceso>>(cbTP || []);
  const [estado, setEstadoPrograma] = useState<E_EstadoFormPrograma>(estadoTest || E_EstadoFormPrograma.Lectura);
  const [valResponsable, setValResponsable] = useState<IUserPickerValue | null>();
  const formValidation = (value: Partial<IPlan>) => {
    let arrErrors: Array<string> = [];
    let arrErrorsText: Array<string> = [];
    if (value.ANIO === "") {
      arrErrors.push("ANIO");
      arrErrorsText.push("Debe ingresar un año");
    } else if (parseInt(value.ANIO ?? "") < new Date().getFullYear()) {
      arrErrorsText.push("El año no puede ser menor al actual");
      arrErrors.push("ANIO");
    } else if (value.ID_AREA_RESPONSABLE === "") {
      arrErrors.push("AREA_RESPONSABLE");
      arrErrorsText.push("Debe seleccionar un área responsable");
    } else if (value.ID_TIPO_PROCESO === "") {
      arrErrors.push("TIPO_PROCESO");
      arrErrorsText.push("Debe seleccionar un tipo de proceso");
    } else if (value.RESPONSABLE === "") {
      arrErrors.push("RESPONSABLE");
      arrErrorsText.push("Debe agregar un responsable");
    }

    if (arrErrorsText.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Debe considerar lo siguiente:</h3>
            {arrErrorsText.map((e) => (
              <p key={e}>{e}</p> //
            ))}
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  let paramsActive = cParamsActiveOrderTitle;
  let search = new URLSearchParams(window.location.search);
  const idProveedor = parseInt(search.get("id") || id_proveedor);
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();

    let resultAllTipoAuditoria: Array<IAreaResponsable> = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_AREA_RESPONSABLE}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboAR(resultAllTipoAuditoria);

    if (idProveedor === 0) {
      setEstadoPrograma(E_EstadoFormPrograma.Agregar);
      console.log(currUser);
      setValResponsable({ mail: currUser.email, name: currUser.name });
    } else {
      if (plan !== undefined) {
        if (plan.ID_ESTADO === 1) {
          setEstadoPrograma(E_EstadoFormPrograma.Agregar);
        }

        try {
          await fillTP(plan.AREA_RESPONSABLE);
        } catch (e) {
          console.log(e);
        }
        setValResponsable({ mail: plan.RESPONSABLE, name: plan.RESPONSABLE_DISPLAY });
        setTP({ value: plan.ID_TIPO_PROCESO, label: plan.TIPO_PROCESO });
        setAR({ value: plan.ID_AREA_RESPONSABLE, label: plan.AREA_RESPONSABLE });
      }
    }
  }, []);

  const handleGuardar = async (id_estado: number) => {
    let params = {
      ID: idProveedor,
      ID_AREA_RESPONSABLE: ar?.value,
      ID_TIPO_PROCESO: tp?.value,
      RESPONSABLE: valResponsable?.mail,
      RESPONSABLE_DISPLAY: valResponsable?.name,
      ANIO: refTxtAnio.current?.value,
      ID_ESTADO: id_estado,
    };
    if (formValidation(params)) {
      try {
        let r = (await postAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/postprograma`, params, { Authorization: `Bearer ${token}` }))
          .result;
        console.log(r);
        let id: number = r.data.data;
        if (id_estado === 1) window.location.href = `agregarprograma?id=${id}&view=1`;
        else window.location.href = `proveedores/home`;
      } catch (e: any) {
        MySwal.fire({
          html: (
            <div>
              <h3>Error al crear programa</h3>
              <p>{e.response.data.msg}</p>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
      }
    }
  };

  const fillTP = async (e: any) => {
    let paramsActiveAR = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "TITULO",
      ORIENTACION: "ASC",
      ACTIVO: true,
      AREA_RESPONSABLE: e,
    };
    let result = await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, paramsActiveAR);

    setComboTP(result.result.data);
  };

  const hasError = (field: string) => {
    return arrErrorEmpty.includes(field) && "error";
  };

  return (
    <div className="row">
      <button
        hidden={true}
        data-testid="btnformvalidation"
        onClick={() => {
          formValidation(plan ?? {});
        }}></button>
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Proveedor</h1>

            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">Programa anual</span>
                  </h6>
                </div>
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">{correlativo}</span>
                  </h6>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Área responsable
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  {estado === E_EstadoFormPrograma.Agregar ? (
                    <Select
                      options={
                        comboAR.map((vcc) => ({
                          value: vcc.ID as number,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${hasError("AREA_RESPONSABLE")}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={async (e: any) => {
                        setAR(e || "");
                        await fillTP(e.label);
                      }}
                      defaultValue={
                        plan
                          ? {
                              value: plan.ID_AREA_RESPONSABLE,
                              label: plan.AREA_RESPONSABLE,
                            }
                          : []
                      }
                    />
                  ) : (
                    <label>{plan?.AREA_RESPONSABLE}</label>
                  )}
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Tipo de proceso
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  {estado === E_EstadoFormPrograma.Agregar ? (
                    <Select
                      options={
                        comboTP.map((vcc) => ({
                          value: vcc.ID as number,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${hasError("TIPO_PROCESO")}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setTP(e || "");
                      }}
                      defaultValue={
                        plan
                          ? {
                              value: plan.ID_TIPO_PROCESO,
                              label: plan.TIPO_PROCESO,
                            }
                          : []
                      }
                    />
                  ) : (
                    <label>{plan?.TIPO_PROCESO}</label>
                  )}
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Año
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    ref={refTxtAnio}
                    type="number"
                    hidden={estado === E_EstadoFormPrograma.Lectura}
                    defaultValue={plan ? plan.ANIO : ""}
                    className={`${hasError("ANIO")} form-control form-control-sm w-50`}
                  />
                  <label hidden={estado !== E_EstadoFormPrograma.Lectura}>{plan?.ANIO}</label>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Responsable
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  {estado === E_EstadoFormPrograma.Agregar ? (
                    <UserPicker
                      name={"detectadoPor"}
                      callback={(id, value) => {
                        setValResponsable(value?.shift() || null);
                      }}
                      id={"detectadoPor"}
                      key={"1"}
                      multi={false}
                      disabled={false}
                      className={`${hasError("RESPONSABLE")} borderColorGris`}
                      defaultValue={valResponsable}
                    />
                  ) : (
                    <label>{plan?.RESPONSABLE_DISPLAY}</label>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <button
                    hidden={estado === E_EstadoFormPrograma.Lectura}
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleGuardar(1)}
                    disabled={isSendingData}>
                    {" "}
                    Grabar
                  </button>
                  <button
                    data-testid="btnguardar"
                    hidden={estado === E_EstadoFormPrograma.Lectura}
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleGuardar(2)}
                    disabled={isSendingData}>
                    {" "}
                    Continuar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => (window.location.href = "/proveedores/home")}
                    disabled={isSendingData}>
                    Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
